const TRUTHY = new Set(['1', 'true', 'yes', 'on']);

const readFlag = (raw: string | undefined): boolean =>
  TRUTHY.has(
    String(raw ?? '')
      .trim()
      .toLowerCase()
  );

/**
 * Whether dark mode (the Settings > Appearance toggle, and the theming it
 * drives) is offered at all.
 *
 * Off by default, so a build has to opt in; the UAT and prod workflows both
 * turn it on today. Gates both the toggle in Settings and the effect of an
 * already-stored `dark_mode_enabled` preference, so an account that enabled
 * it can't end up dark in a build where the flag is off.
 *
 * Build-time: Vite inlines REACT_APP_* via `define`, so this is fixed per
 * build rather than per request. index.html's pre-paint theme script reads
 * the same variable (substituted by vite.config.js) and must keep accepting
 * the same truthy values as TRUTHY above.
 */
export const isDarkModeEnabled = (): boolean =>
  readFlag(process.env.REACT_APP_ENABLE_DARK_MODE);
